import React from 'react'
import {ReactComponent as UsersSvg} from '../../assets/users.svg';
// import UsersSvg from '../../assets/users.svg';
import {ReactComponent as SettingsSvg} from '../../assets/settings.svg';
// import SettingsSvg from '../../assets/settings.svg';
import {ReactComponent as CalcSvg} from '../../assets/calculator.svg';
// import CalcSvg from '../../assets/calculator.svg';
import { Link, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Users } from './Users';
import { EmptyPage } from '../EmptyPage';
import { accessor } from '../../helpers';
import { useSelector } from 'react-redux';
import { Calculation } from './Calculation';
import { Other } from './Other';


export const SettingsPage = () => {

  const {pathname:fullpath} = useLocation();
  const path = fullpath.split('/')[fullpath.split('/').length-1];
  const userInfo = useSelector((state) => state.auth);
  const systemUserId = useSelector((state) => state.settings.botTelegramId);
  const isSystemAccount = systemUserId === userInfo.telegramId;
  const usersInteractAccess = accessor.usersInteract(userInfo);

  return (
    <section className='settings-page page'>
      <div className="settings__container">
        <div className="settings__switcher">
          {usersInteractAccess && <Link to="/settings/users" className={`switch button ${path === 'users' ? 'active' : ''}`}><UsersSvg height={48} width={48} /></Link>}
          {isSystemAccount && <Link to="/settings/calc" className={`switch button ${path === 'calc' ? 'active' : ''}`}><CalcSvg height={48} width={48} /></Link>}
          <Link to="/settings/other" className={`switch button ${path === 'other' ? 'active' : ''}`}><SettingsSvg height={48} width={48} /></Link>
        </div>
        <div className="settings__content">
          <Routes>
              <Route path="/" element={<Navigate to="/settings/users" />} />
              <Route path="users/*" element={<Users />} />
              <Route path="calc" element={<Calculation isSystemAccount={isSystemAccount} />} />
              <Route path="other" element={<Other />} />
              <Route path="*" element={<EmptyPage message="Страница не найдена" />} />
          </Routes>
        </div>
      </div>
    </section>
  )
}
